import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import Spinner from "@accredo/fe-shared/components/Spinner.jsx";
import { Box, Stack, Typography } from "@mui/material";
import { useBlogPostActions } from "../../hooks/useBlogPostActions.jsx";
import BlogBodyRenderer from "../admin/blog/components/BlogBodyRenderer.jsx";
import BlogPostTags from "../admin/blog/components/BlogPostTags.jsx";

export default function BlogPostShowPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  const { findById, state: blogState } = useBlogPostActions();
  const blogPost = blogState.data.data;

  const { blog_post_id: blogPostId } = useParams();

  // const [blogPost, setBlogPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const blogPostDisplayName = blogPost
    ? `${blogPost.overline ? `${blogPost.overline}: ` : ""}${blogPost.headline}` ||
      `Post #${blogPostId}`
    : `Post #${blogPostId}`;

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Was ist neu?", path: "/blog" },
      {
        name: blogPostDisplayName,
        path: `/blog/${blogPostId}`,
      },
    ]);
  }, [setBreadcrumbs, blogPostDisplayName, blogPostId]);

  const fetchData = useCallback(async () => {
    await findById(blogPostId, {
      setIsLoading: setIsLoading,
      options: {
        params: {
          include: ["authors", "customers", "creator", "roles", "tags"],
        },
      },
    });
  }, [blogPostId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading) {
    return <Spinner />;
  }

  if (!blogPost) {
    return (
      <Box>
        <Typography variant="h3" sx={{ mb: 3 }}>
          News-Beitrag nicht gefunden
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        spacing={4}
        sx={{ maxWidth: 600, margin: "auto" }}
      >
        <Box sx={{ maxWidth: 600, margin: "auto" }}>
          <BlogPostTags blogPost={blogPost} />

          <Typography variant="body1" sx={{ pt: 3 }}>
            {blogPost.overline}
          </Typography>

          <Typography variant="h2" sx={{ mb: 3 }}>
            {blogPost.headline}
          </Typography>

          <Typography variant="body1" sx={{ mb: 3, fontWeight: "bold" }}>
            {blogPost.teaser}
          </Typography>

          <BlogBodyRenderer body={blogPost.body} />
        </Box>
      </Stack>
    </>
  );
}
